<template>
  <div class="bg" v-show="show">
    <input style="position: absolute; top: -100000000000px" ref="wordList" type="text">
    <div class="wrapper">
      <img src="@assets/img/interview/close.svg" alt="close" class="close" @click="close()">
      <div v-if="!showHref" class="share-container">
        <div class="title">分享设置</div>
        <div class="content">
          <p class="tips">获取分享链接的人可查看分享</p>
          <div class="list">
            <p>分享形式：</p>
            <div @click="ceateFour();isSign = !isSign;timeIndex = 0" class="ratio">
              <p :class="{on: isSign}">
                <i v-show="isSign"></i>
              </p>
              <span>加密</span>
            </div>
            <span v-show="isSign" class="code">提取码：{{code}}</span>
          </div>
          <div v-show="isSign" class="list">
            <p>有效期：</p>
            <div v-click-outside="closeTimeList" :class="{input: true,un: !isSign}">
              <p @click="changeShowTimeList()">{{timeList[timeIndex].name}}</p>
              <i @click="changeShowTimeList()"></i>
              <ul v-if="showTimeList" class="input-list">
                <li @click="cahngeTime(index)" v-for="(item,index) in timeList" :key="index">
                  <span>{{item.name}}</span>
                  <i v-if="item.select"></i>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="btns">
          <p @click="createHref" class="confirm green">创建链接</p>
          <i v-if="showLoad"></i>
        </div>
      </div>
      <div v-else class="href-container">
        <div class="notice">
          <div class="left"></div>
          <div class="right">
            <p>分享链接及提取码已复制</p>
            <span>获取分享链接的人可查看分享</span>
          </div>
        </div>
        <div class="input-container">
          <div class="input">
            <p>{{href}}</p>
          </div>
          <div @click="copyText" class="btn">复制链接</div>
        </div>
        <div class="time-container">
          <p v-if="isSign">
            提取码：
            <span>{{code}}</span>
          </p>
          <p>
            有效期：
            <span>{{timeList[timeIndex].name}}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import common from "@common/common";
import { apis } from "@common/config";
import vClickOutside from "v-click-outside";

export default {
  name: 'shareCode',
  directives: {
    clickOutside: vClickOutside.directive
  },
  data() {
    return {
      show: true,
      config: {},
      r: null,
      showTimeList: false,
      timeList: [
        {name: '1小时', select: true},
        {name: '3小时', select: false},
        {name: '1天', select: false},
        {name: '7天', select: false}
      ],
      timeIndex: 0,
      isSign: false,
      showLoad: false,
      code: '',
      showHref: false,
      href: ''
    }
  },
  methods: {
    changeShowTimeList() {
      if(this.isSign){
        this.showTimeList = !this.showTimeList
      }
    },
    open(c, r) {
      console.log(c,r)
      this.config = c
      this.r = r
      this.show = true
    },
    close() {
      this.show = false
    },
    cahngeTime(index) {
      this.timeIndex = index;
      this.timeList.forEach((el,key) => {
        if(key == index){
          el.select = true
        }else{
          el.select = false
        }
      });
      this.showTimeList = false;
    },
    closeTimeList() {
      this.showTimeList = false;
    },
    ceateFour() {
      this.code = common.create4()
    },
    createHref() {
      if(this.showLoad) return
      let timeIndex = this.timeIndex;
      timeIndex = timeIndex + 1;
      const info = {
        file_id: this.config,
        is_encrypt: this.isSign ? 1 : 0,
        password: this.isSign ? this.code : '',
        expire: timeIndex
      };
      this.showLoad = true;
      common.myFetch(apis.fileShare, info).then(r => {
        if (r) {
          console.log(r)
          this.showLoad = false;
          this.href = r.share_url
          this.showHref = true;
          // this.$toast(r)
        }else{
          this.showLoad = false;
        }
      });
    },
    copyText() {
      const wordListDom = this.$refs.wordList;
      wordListDom.value = `链接：${this.href} 提取码：${this.code ? this.code : '无需提取码'} 有效期：${this.timeList[this.timeIndex].name}`;
      wordListDom.select();
      // 执行浏览器复制命令
      document.execCommand("Copy");
      this.$toastConfirm("分享链接及提取码已复制");
    }
  }
}
</script>

<style lang="less" scoped>
  @import '../../assets/css/global.less';
  .bg {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.70);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1008;
  }
  .wrapper {
    max-height: 302px;
    width: 720px;
    background-color: @bg;
    box-shadow: 4px 4px 10px 0 rgba(5, 10, 15, 0.05);
    border-radius: 4px;
    z-index: 99998;
    display: flex;
    flex-direction: column;
    // justify-content: center;
    // align-items: center;
    position: relative;

    .title {
      font-size: 20px;
      line-height: 28px;
      color: #050F0F;
      font-weight: bold;
      margin: 0 auto 14px;
      text-align: center;
    }

    .content {
      display: flex;
      flex-direction: column;

      .tips {
        font-size: 14px;
        line-height: 20px;
        color: #829191;
        font-weight: 500;
        margin-bottom: 20px;
      }

      .list {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-bottom: 20px;

        &>p {
          width: 70px;
          font-size: 14px;
          line-height: 20px;
          font-weight: bold;
          color: #050F0F;
          margin-right: 8px;
        }

        .ratio {
          display: flex;
          flex-direction: row;
          align-items: center;
          margin-right: 20px;
          font-size: 14px;
          line-height: 20px;
          color: #050F0F;
          font-weight: bold;

          p {
            width: 16px;
            height: 16px;
            border-radius: 50%;
            border: 1px solid #41B48C;
            box-sizing: border-box;
            user-select: none;
            cursor: pointer;
            margin-right: 8px;
            &.on {
              position: relative;
              background: #41B48C;

              i {
                position: absolute;
                display: block;
                left: 50%;
                top: 50%;
                margin-left: -3px;
                margin-top: -3px;
                width: 6px;
                height: 6px;
                border-radius: 50%;
                background: #FFF;
              }
            }
          }
        }

        .code {
          font-size: 14px;
          line-height: 20px;
          color: #41B48C;
          font-weight: bold;
        }

        .input {
          display: flex;
          flex-direction: row;
          align-items: center;
          position: relative;
          width: 320px;
          height: 40px;
          background: rgba(185, 195, 195, 0.2);
          border-radius: 4px;
          padding: 0 20px;
          box-sizing: border-box;
          font-size: 14px;
          line-height: 40px;
          color: #050F0F;

          &.un {
            opacity: 0.7;
          }

          p {
            flex: 1;
            height: 100%;
            overflow: hidden;
          }

          i {
            width: 10px;
            height: 6px;
            display: block;
            background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAGCAYAAAD68A/GAAAABGdBTUEAALGPC/xhBQAAAHtJREFUCB1j3HXkyFaG///5Obi5A+2MjF4zIIFD586J/vj6dT0DI+NHJpCi/wwM1t+/fdsPkoCpA7FBYiA5kBpGmACQow3UeZWTi8sRpBikCFmMESSIrhgkhqwI5CSwQpA4imKQANR0mLvhCkFyO48eFWP8928diI3uOQBKTlEqfGTG1AAAAABJRU5ErkJggg==) no-repeat;
            background-position: center center;
            background-size: 100% 100%;
          }

          .input-list {
            position: absolute;
            top: 50px;
            left: 0;
            z-index: 9999999;
            background: #FFF;
            display: flex;
            flex-direction: column;
            box-shadow: 4px 4px 10px 0 rgba(5, 10,15 , 0.05);
            border-radius: 4px;

            li {
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              align-items: center;
              width: 320px;
              padding: 5px 20px;
              box-sizing: border-box;
              font-size: 14px;
              user-select: none;
              cursor: pointer;

              i {
                display: block;
                width: 14px;
                height: 11px;
                background: url('../../assets/img/interview/select.svg') no-repeat;
                background-position: center center;
                background-size: 100% 100%;
              }

              &:hover {
                background: rgba(65,180,140,.15);
              }
            }
          }

          // .arrow {
          //   content: "";
          //   display: block;
          //   width: 10px;
          //   height: 6px;
          //   position: absolute;
          //   top: 0px;
          //   right: 9px;
          //   bottom: 0px;
          //   margin: auto;
          //   background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAGCAYAAAD68A/GAAAABGdBTUEAALGPC/xhBQAAAHtJREFUCB1j3HXkyFaG///5Obi5A+2MjF4zIIFD586J/vj6dT0DI+NHJpCi/wwM1t+/fdsPkoCpA7FBYiA5kBpGmACQow3UeZWTi8sRpBikCFmMESSIrhgkhqwI5CSwQpA4imKQANR0mLvhCkFyO48eFWP8928diI3uOQBKTlEqfGTG1AAAAABJRU5ErkJggg==) no-repeat;
          //   background-position: right center;

          //   &.on {
          //     transform: rotate(180deg);
          //   }
          // }
        }
      }
    }

    .close {
      position: absolute;
      right: 28px;
      top: 18px;
      cursor: pointer;
    }
  
    .btns {
      position: relative;
      height: 40px;
      align-items: center;
      display: flex;
      justify-content: center;

      i {
        position: absolute;
        right: 128px;
        top: 50%;
        margin-top: -12px;
        display: block;
        width: 22px;
        height: 24px;
        background: url('./assets/load.svg') no-repeat;
        background-position: center center;
        background-size: 100% 100%;
        animation: rotate 1.2s linear infinite;
        
      }
    }
    .confirm, .cancel {
      background-color: @bg;
      width: 120px;
      text-align: center;
      line-height: 40px;
      height: 40px;
      border-radius: 4px;
      border: 1px solid @green;
      color: @green;
      font-size: 14px;
      // box-shadow: 2px 1px 8px 0 rgba(0, 0, 0, 0.1);
      cursor: pointer;
      &:hover {
        .btnHover;
      }
      &:active {
        .btnActive;
      }
    }
    .green {
      margin-right: 20px;
      color: #fff;
      background-color: @green;
    }

    .share-container {
      padding: 40px 120px;
      box-sizing: border-box;
    }

    .href-container {
      display: flex;
      flex-direction: column;
      padding: 60px 80px;
      box-sizing: border-box;

      .notice {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-bottom: 16px;

        .left {
          width: 40px;
          height: 40px;
          background: url('./assets/success.svg') no-repeat;
          background-position: center center;
          background-size: 100% 100%;
          margin-right: 18px;
        }

        .right {
          display: flex;
          flex-direction: column;

          p {
            font-size: 20px;
            line-height: 28px;
            color: #050F0F;
            font-weight: 500;
          }

          span {
            font-size: 14px;
            line-height: 20px;
            color: #829191;
          }
        }
      }

      .input-container {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-left: 58px;

        .input {
          display: flex;
          align-items: center;
          width: 362px;
          height: 40px;
          background: rgba(185, 195, 195, 0.2);
          border-radius: 4px;
          margin-right: 20px;
          padding: 0 20px;
          box-sizing: border-box;

          p {
            flex: 1;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
          }
        }

        .btn {
          width: 120px;
          height: 40px;
          line-height: 40px;
          background: #41B48C;
          border-radius: 4px;
          font-size: 14px;
          color: #FFFFFF;
          text-align: center;
          user-select: none;
          cursor: pointer;
        }
      }

      .time-container {
        margin-left: 58px;
        display: flex;
        flex-direction: row;
        align-items: center;
        font-size: 14px;
        line-height: 20px;
        font-weight: bold;
        color: #050F0F;
        margin-top: 20px;

        p {
          margin-right: 60px;
        }

        span {
          color: #41B48C;
        }
      }
    }
  }

  @keyframes rotate {
    0%{
      transform: rotate(0deg);
    }
    100%{
      transform: rotate(360deg);
    }
  }
</style>
